<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <!-- <v-col class="pa-2" cols="12" md="6">
          <div class="rowinfo">
            <v-text-field
              v-model="options.data"
              :readonly="readonly"
              append-icon="mdi-link-variant-plus"
              dense
              label="لینک"
              outlined
              class="contentinfo"
              placeholder="qr2.in"
              @input="$emit('update')"
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-data-options`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="لینک"
            />
          </div>
        </v-col> -->
        <v-col cols="12" md="6" class="d-flex justify-center my-1">
          <div class="visual-preview-container">
            <div class="measure-line top-measure">
              <span>300px</span>
            </div>
            
            <div class="qr-margin-box" :style="marginStyle">  
              <div class="qr-image blue-svg-mask"></div>            
            </div>

            <div class="measure-line right-measure">
              <span>300px</span>
            </div>
          </div>
        </v-col>

        <span class="text--secondary mx-1 my-2">ابعاد کیوآر:</span>
        <span class="font-weight-bold mx-1 my-2"> 300px X 300px </span>
<!-- 
        <v-col class="pa-2" col="12" md="4">
          <div class="rowinfo">
            <v-text-field
              v-model="options.margin"
              disabled
              dense
              :label="$t('margin')"
              min="0"
              outlined
              type="number"
              @input="updateSizes($event, 'margin')"
              class="contentinfo"
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-margin-options`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('margin')"
            />
          </div>
        </v-col>

        <v-col class="pa-2" col="12" md="4">
          <div class="rowinfo">
            <v-text-field
              v-model="options.width"
              dense
              disabled
              :label="$t('width')"
              min="0"
              outlined
              type="number"
              @input="updateSizes($event, 'width')"
              class="contentinfo"
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-width-options`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('width')"
            />
          </div>
        </v-col>

        <v-col class="pa-2" col="12" md="4">
          <div class="rowinfo">
            <v-text-field
              v-model="options.height"
              dense
              disabled
              :label="$t('height')"
              min="0"
              outlined
              type="number"
              @input="updateSizes($event, 'height')"
              class="contentinfo"
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-height-options`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('height')"
            />
          </div>
        </v-col> -->

        <v-col class="d-flex align-center grey--text" cols="12">
          {{ $t('background_color') }}
          <v-divider class="mx-2" />
        </v-col>
        <v-col cols="12" md="6">
          <v-switch v-model="bgTranSwitch" label="پس‌زمینه شفاف" />
        </v-col>


        <!-- <v-col cols="12" md="6" v-if="!bgTranSwitch">
          <v-switch v-model="bgSwitch" :label="$t('gradient_color')" disabled />
        </v-col> -->

        <template v-if="bgSwitch">
          <v-col class="pa-2" cols="12" md="6">
            <v-radio-group
              v-model="options.backgroundOptions.gradient.type"
              class="ma-0"
              row
              @change="$emit('update', true)"
            >
              <v-radio :label="$t('linear')" value="linear" />
              <v-radio :label="$t('radial')" value="radial" />
            </v-radio-group>
          </v-col>

          <v-col class="pa-2" cols="12">
            <v-slider
              v-model="computedRotation"
              append-icon="mdi-rotate-360"
              :label="$t('color_rotation')"
              max="360"
              min="0"
              thumb-label
              track-color="grey"
              @input="$emit('update', true)"
            >
              <template v-slot:thumb-label="{ value }">
                <div
                  class="d-flex align-center justify-center"
                  style="
                    width: 20px;
                    height: 20px;
                    background-color: rgba(12, 15, 26, 0.7);
                    border-radius: 50%;
                  "
                >
                  {{ value }}°
                </div>
              </template>
            </v-slider>
          </v-col>

          <v-col class="pa-2" cols="12" md="6" v-if=!bgTranSwitch>
            <color-picker
              v-model="options.backgroundOptions.gradient.colorStops[0].color"
              :label="$t('first_color')"
              @input="$emit('update', true)"
            />
          </v-col>

          <v-col class="pa-2" cols="12" md="6" v-if=!bgTranSwitch>
            <color-picker
              v-model="options.backgroundOptions.gradient.colorStops[1].color"
              :label="$t('second_color')"
              @input="$emit('update', true)"
            />
          </v-col>
        </template>

        <v-col v-if="!bgSwitch && !bgTranSwitch" class="pa-2" cols="12" md="6">
          <color-picker
            v-model="options.backgroundOptions.color"
            :label="$t('background_color_label')"
            @input="$emit('update', true)"
          />
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import ColorPicker from "@/view/pages/qrland/components/colorPicker";

export default {
  name: "qrCodeDataauto",

  components: { ColorPicker },

  props: {
    value: Object,
    readonly: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({
    bgTranSwitch:false,
    helpData: [],
    serviceName: "Qrland",
    componentName: "qrCodeData",
    bgSwitch: false,
    rotation: 0,
  }),

  computed: {
    options: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedRotation: {
      get() {
        return this.rotation;
      },
      set(val) {
        this.rotation = val;
        this.options.backgroundOptions.gradient.rotation =
          (val * Math.PI) / 180;
        this.$emit("update", true);
      },
    },
  },

  watch: {
    bgTranSwitch(val) {
      if (val) {
        this.bgSwitch = false;        
        this.options.backgroundOptions.color = "#ffffff00";
      } else {
        this.options.backgroundOptions.color = "#ffffffff"; 
      }
      this.$emit("update", true);
    },
    bgSwitch(val) {
      if (!val) this.options.backgroundOptions.gradient = null;
      else {
        this.options.backgroundOptions.gradient = {
          type: "linear",
          rotation: 0,
          colorStops: [
            {
              offset: 0,
              color: "#ffffffff",
            },
            {
              offset: 1,
              color: "#ffffffff",
            },
          ],
        };
      }
      this.$emit("update", true);
    },
  },

  methods: {
    updateSizes(e, field) {
      if (e < 0) this.options[field] = 0;
      this.$emit("update");
    },
  },
};
</script>

<style scoped>
.visual-preview-container {
  position: relative;
  display: inline-block;
  margin-top: 20px;
  margin-bottom: 20px;
}

.qr-margin-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.qr-image {
  width: 70px;
  height: 70px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  
}

.measure-line {
  position: absolute;
  border-color: #011554;
  color: #011554;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.top-measure {
  top: -25px;
  left: 0;
  right: 0;
  height: 15px;
  border-top: 2px solid #011554;
  border-left: 2px solid #011554;
  border-right: 2px solid #011554;
}

.top-measure span {
  background: white;
  padding: 0 8px;
  transform: translateY(-50%);
}

.right-measure {
  right: -25px;
  top: 0;
  bottom: 0;
  width: 15px;
  border-top: 2px solid #011554;
  border-right: 2px solid #011554;
  border-bottom: 2px solid #011554;
}

.right-measure span {
  writing-mode: vertical-rl;
  background: white;
  padding: 8px 0;
  transform: translateX(50%);
}
.margin-indicator {
  position: absolute;
  font-size: 11px;
  color: #757575;
  font-weight: bold;
  z-index: 2;
}
.top-left {
  top: 5px;
  left: 5px;
}
.link-icon {
  z-index: 1;
  color: #011554;
}
.blue-svg-mask {
  width: 50px; 
  height: 50px;
  background-color: #011554;   
  -webkit-mask: url('/media/img/Q.svg') no-repeat center / contain;
  mask: url('/media/img/Q.svg') no-repeat center / contain;
}
.input-link-bracket {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px; 
  width: 15px;
  border-top: 2px solid #011554;
  border-bottom: 2px solid #011554;
  border-right: 2px solid #011554; 
  position: relative;
}

.input-link-bracket .link-icon {
  position: absolute;
  right: -12px; 
  background-color: white;
  color: #011554 !important; 
  padding: 2px;
  z-index: 1;
}
</style>
